import { PageProps, navigate } from 'gatsby'
import { useMemo } from 'react'

import {
  Answer,
  CopyLinkButton,
  GoToSearchButton,
  QAPanel,
  Question,
  SkillApi,
} from '@karakuri-web/faq-component'
import { AnswerPageContext, Breadcrumb, Hierarchy } from '@karakuri-web/faq-type'

import { Session } from '../session'
import { EventTrigger } from '../utils/event-trigger'

import { Data } from './interface'

type Props = Pick<
  PageProps<Data, AnswerPageContext, { hierarchies?: Hierarchy[] }>,
  'data' | 'location' | 'pageContext'
> & {
  breadcrumb: Breadcrumb
  skillApi: SkillApi
}

export function AnswerWidget({ data, pageContext, breadcrumb, skillApi, location }: Props) {
  const { ask, contents, actions, questionnaireMessages } = pageContext || {}
  const { answers, cardId, operatorEscalationKeyword, karakuriWebRootUrl, info } = pageContext

  const faqUrl = useMemo(() => {
    if (!data.settingYaml.siteUrl) return null
    try {
      return new URL(data.settingYaml.siteUrl).origin + '/answer/' + cardId
    } catch (e) {
      console.error('Invalid siteUrl in settingYaml:', data.settingYaml.siteUrl, e)
      return null
    }
  }, [data.settingYaml.siteUrl, cardId])

  const handleClick = (path: string) => {
    navigate(path, {
      state: {
        hierarchies: [
          ...breadcrumb.hierarchies,
          { title: pageContext.ask, link: location.pathname },
        ],
      },
    })
  }
  const search = location?.search.indexOf('search=true') > -1
  if (!contents || !cardId) {
    return null
  }
  function feedbackAction(action: 'yes' | 'no', callback: () => void) {
    const feedbackString = action === 'yes' ? 'ok' : 'ng'
    callback()
    EventTrigger.feedback(feedbackString)
  }

  const handleClickGoToSearchButton = () => {
    navigate(-1)
  }

  return (
    <QAPanel className="faq-answer">
      {faqUrl && <CopyLinkButton url={faqUrl} />}
      <Question q={ask || ''} info={info} />
      <Answer
        contents={contents}
        actions={actions}
        onClick={handleClick}
        cardId={cardId}
        answers={answers}
        operatorEscalationKeyword={operatorEscalationKeyword}
        karakuriWebRootUrl={karakuriWebRootUrl}
        messages={questionnaireMessages}
        wordsQuestionnaire={data?.settingYaml?.words?.questionnaire}
        info={info}
        session={Session}
        onFeedback={feedbackAction}
        skillApi={skillApi}
      />
      {search && <GoToSearchButton onClick={handleClickGoToSearchButton} />}
    </QAPanel>
  )
}
